import React, { FC } from 'react';
import { HeaderSize, HeaderText } from '@/components/ui/HeaderText';
import Accordion from '../Accordion/Accordion';
import { TypeAccordionSectionFields } from '@/core/generated-types';
import { TW_VERTICAL_PADDINGS } from '@/core/constants';
import classNames from 'classnames';
import { RichText } from '../RichText';
import { Document } from '@contentful/rich-text-types';
import { DynamicComponent } from '../DynamicComponent';

const AccordionSection: FC<TypeAccordionSectionFields> = ({
  title,
  subTitle,
  items,
  containerVerticalPadding = 0,
  containerHorizontalPadding = 0,
  // Note: This default was recommended by Teri for all AccordionSections. This can
  // be overridden by adding an explicit maxWidth to an AccordionSection in Contentful
  maxWidth = '800px',
  anchorId,
  richText,
  backgroundColor,
}) => {
  return (
    <>
      {anchorId && (
        <div
          id={anchorId}
          className="relative -top-[110px]"
          data-testid="accordion-section-anchor"
        />
      )}
      <div className={`bg-${backgroundColor?.fields?.color}`}>
        <div
          className={classNames(
            TW_VERTICAL_PADDINGS[containerVerticalPadding],
            'container',
            'mx-auto',
            `px-${containerHorizontalPadding}`,
          )}
          style={{ maxWidth }}
          data-testid="accordion-section-container"
        >
          <HeaderText
            size={HeaderSize.H2}
            text={title}
            align="center"
            classes="pb-8 md:pb-12"
          />
          <HeaderText
            size={HeaderSize.H2}
            text={subTitle}
            align="left"
            classes="pb-6 text-indigo"
          />
          {items &&
            items.map((item) => {
              item.sys.contentType.sys.id = 'accordion';
              return <DynamicComponent component={item} key={item.sys.id} />;
            })}
          {richText && (
            <div className="border-t pt-8 text-center text-sm -mb-8">
              <RichText
                openLinkSameWindow={true}
                content={richText as Document}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default React.memo(AccordionSection);
